import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import { Observable } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import {
  AccessRights,
  UserRole
} from 'src/app/features/role/user-role/user-role'
import { BulkAction } from 'src/app/shared/interfaces'

import { Component, Input, OnInit } from '@angular/core'
import { UntilDestroy } from '@ngneat/until-destroy'
import { Dictionary } from '@ngrx/entity'
import { Store } from '@ngrx/store'
import { Member } from 'src/app/features/member/member'
import { memberSelectors } from 'src/app/features/member/member.selectors'
import { MessageService } from 'src/app/features/message/message.service'
import { Product } from 'src/app/features/product/product'
import { productSelectors } from 'src/app/features/product/product.selectors'
import { SerieProposal, SerieProposalStatus } from '../serie-proposal'
import { serieProposalSelectors } from '../serie-proposal.selectors'
import { SerieProposalInitialRequestModalComponent } from '../initial-request-modal/initial-request-modal.component'

@UntilDestroy()
@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class SerieProposalShowModalComponent implements OnInit {
  @Input() serieProposalId: number

  public productEntities$: Observable<Dictionary<Product>>
  public activeTab: string = 'general'

  public selectedLanguage$: Observable<string>
  public BulkAction = BulkAction
  public accessRights = AccessRights
  public loadingMember$: Observable<boolean>
  public serieProposal$: Observable<SerieProposal>
  public memberEntities$: Observable<Dictionary<Member>>
  public currentUserRole$: Observable<UserRole>
  public serieProposalStatus = SerieProposalStatus

  constructor(
    private bsModalRef: BsModalRef,
    private store: Store<AppState>,
    public messageService: MessageService,
    private modalService: BsModalService
  ) {}

  ngOnInit() {
    this.serieProposal$ = this.store.select(
      serieProposalSelectors.selectById,
      this.serieProposalId
    )
    this.productEntities$ = this.store.select(productSelectors.selectEntities)
    this.memberEntities$ = this.store.select(memberSelectors.selectEntities)
  }

  public onClickShowInitialRequest(serieProposal: SerieProposal) {
    this.modalService.show(SerieProposalInitialRequestModalComponent, {
      initialState: {
        serieProposal
      },
      class: 'modal-lg'
    })
  }

  public cancel() {
    this.bsModalRef.hide()
  }
}
